"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrientations = void 0;
var _react = require("react");
var useOrientations = function useOrientations(ref, bounds, defaultVerticalOrientation, defaultHorizontalOrientation) {
  var _ref = (0, _react.useState)(0),
    _ref2 = _slicedToArray(_ref, 2),
    height = _ref2[0],
    setHeight = _ref2[1];
  var _ref3 = (0, _react.useState)(0),
    _ref4 = _slicedToArray(_ref3, 2),
    width = _ref4[0],
    setWidth = _ref4[1]; // eslint-disable-next-line react-hooks/exhaustive-deps
  (0, _react.useLayoutEffect)(function () {
    setHeight(ref.current.clientHeight);
    setWidth(ref.current.clientWidth);
  });

  // Set default value
  var verticalOrientation = defaultVerticalOrientation;
  var horizontalOrientation = defaultHorizontalOrientation;
  if (defaultVerticalOrientation === 'below' && bounds.bottom + height > window.innerHeight) {
    verticalOrientation = 'above';
  }
  if (defaultVerticalOrientation === 'above' && bounds.top - height < 0) {
    verticalOrientation = 'below';
  }
  if (defaultHorizontalOrientation === 'right' && bounds.right + width > window.innerWidth) {
    horizontalOrientation = 'left';
  }
  if (defaultHorizontalOrientation === 'left' && bounds.left - width < 0) {
    horizontalOrientation = 'right';
  }
  return {
    verticalOrientation: verticalOrientation,
    horizontalOrientation: horizontalOrientation
  };
};
exports.useOrientations = useOrientations;